import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export function BasicInfoPage() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100">
      <Card className="mx-auto max-w-sm">
        <CardHeader>
          <CardTitle className="text-xl">{t('basicInfo.title')}</CardTitle>
          <CardDescription>{t('basicInfo.description')}</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid gap-4">
            <div className="grid grid-cols-2 gap-4">
              <div className="grid gap-2">
                <Label htmlFor="first-name">{t('basicInfo.firstName')}</Label>
                <Input id="first-name" placeholder="Taro" required />
              </div>
              <div className="grid gap-2">
                <Label htmlFor="last-name">{t('basicInfo.lastName')}</Label>
                <Input id="last-name" placeholder="Yamada" required />
              </div>
            </div>
            <div className="grid gap-2">
              <Label htmlFor="email">{t('basicInfo.email')}</Label>
              <Input id="email" type="email" placeholder="m@example.com" required disabled />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="password">{t('basicInfo.password')}</Label>
              <Input id="password" type="password" required />
            </div>
            <Button type="submit" className="w-full">
              {t('basicInfo.submitButton')}
            </Button>
          </div>
          <div className="mt-4 text-center text-sm">
            {t('basicInfo.alreadyHaveAccount')}{' '}
            <Link to="/login" className="underline">
              {t('basicInfo.loginLink')}
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
